import React, { useEffect, useRef } from 'react';

import { cn } from '@change/ds-utils';

// TODO: This is a temporary component that should be removed once the new design system is implemented
export const Popover: React.FC<PopoverProps> = ({ children, className, isOpen, onClose, trigger }) => {
	const popoverRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (popoverRef.current && !popoverRef.current.contains(event.target as Node)) {
				onClose();
			}
		};

		const handleBlur = (event: FocusEvent) => {
			if (popoverRef.current && !popoverRef.current.contains(event.relatedTarget as Node)) {
				onClose();
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
			document.addEventListener('focusout', handleBlur);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('focusout', handleBlur);
		};
	}, [isOpen, onClose]);

	return (
		<div ref={popoverRef} className="relative block w-full">
			{trigger}
			<div
				className={cn(
					'absolute top-full z-10 mt-1',
					className,
					'bg-fill-inverse-strong w-full rounded-small border shadow-lg',
					isOpen ? 'block' : 'hidden',
					'max-h-96 overflow-y-auto',
				)}
			>
				{children}
			</div>
		</div>
	);
};

type PopoverProps = {
	children: React.ReactNode;
	className?: string;
	isOpen: boolean;
	onClose: () => void;
	trigger: React.ReactNode;
};
